import React from 'react';

const Popup = (props) => {

    return (
        <>
            {(props.is_big === 1) ?
                <div className="fixed bg-[#00000050] z-10 w-full h-screen -top-2 left-0">
                    <div className="relative w-[60%] min-w-fit m-auto max-h-[70vh] bg-white rounded border-solid border-ash mt-40 overflow-hidden custom-scroll-auto">
                        {props.content}
                    </div>
                </div>
                :
                <div className="fixed bg-[#00000050] z-10 w-full h-screen top-0 left-0">
                    <div className="relative w-[25%] min-w-fit m-auto max-h-[70vh] bg-white rounded border-solid border-ash mt-40 custom-scroll-auto">
                        {props.content}
                    </div>
                </div>
            }

        </>
    );
};

export default Popup;